export function esFechaValida(fechaStr) {
    return !isNaN(Date.parse(fechaStr));
}